import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        item: {
            display: 'flex',
            flexDir: 'column',
            alignItems: 'flex-start',
            alignSelf: 'stretch',
            gap: ['medium.base', 'medium.sm', 'medium.md', 'small.lg'],
            px: remCalc(0),
            paddingTop: remCalc(0),
            marginY: remCalc(11),
            border: 'none',
            color: 'text.default',
        },
        itemButton: {
            textStyle: 'body-large',
            fontWeight: 'regular',
            cursor: 'pointer',
        },
    },
}
